import React, { FC, useEffect } from 'react'
import APP1 from '../../../../app/assets/images/projectImage/moodyMonthImage/app1.webp'
import APP2 from '../../../../app/assets/images/projectImage/moodyMonthImage/app2.webp'
import APP3 from '../../../../app/assets/images/projectImage/moodyMonthImage/app3.webp'
import { motion, useAnimation } from 'framer-motion'


const MoodyMonthAppOverview = () => {
    const fadeInUp = {
        hidden: { opacity: 0, y: 60 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    const fadeInLeft = {
        hidden: { opacity: 0, x: 60 },
        visible: { 
            opacity: 1, 
            x: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    const fadeInRight = {
        hidden: { opacity: 0, x: -60 },
        visible: { 
            opacity: 1, 
            x: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    const floatAnimation = {
        hidden: { y: 0 },
        visible: {
            y: [-10, 0, -10],
            transition: {
                duration: 4,
                ease: "easeInOut",
                repeat: Infinity,
                repeatType: "reverse" as const
            }
        }
    };

    return (
        <div className="bg-darkGreyPrimary py-8 md:py-16">
            <motion.div 
                className='flex flex-col md:flex-row relative items-center md:items-end md:justify-end gap-5 md:gap-10 mb-8 md:mb-16'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
            >
                <motion.img 
                    src={APP1} 
                    alt="Mood tracker app screen" 
                    className="w-[70%] md:w-[50%] lg:w-[35%] z-20 order-1 md:order-1" 
                    variants={floatAnimation}
                />
                <motion.div 
                    className="w-full md:max-w-[50%] bg-moody-gradient p-6 md:p-16 pb-10 md:pb-24 relative order-2 md:order-2 mt-6 md:mt-0 md:mb-[6%]"
                    variants={fadeInRight}
                >
                    <div className='absolute left-0 md:-left-16 -top-16 md:-top-52'>
                        <motion.div 
                            className="w-full text-center text-[3rem] sm:text-[4rem] md:text-[7rem] lg:text-[9rem] xl:text-[11rem] font-bold text-[#1F2424]"
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 1 }}
                            viewport={{ once: false }}
                        >
                            MIND
                        </motion.div>
                    </div>
                    <div className='text-2xl md:text-3xl font-bold text-white mb-2 md:mb-4'>Overview</div>
                    <div className='text-[#e0e0e0] text-base md:text-lg leading-relaxed'>
                        Excellence care clinics operates as an independent center for
                        pain treatment, aiding patients with complicated cases
                        that do not respond to usual treatments. The care is
                        delivered by pain specialists and nurses. They are based
                        in Velsen-Noord, the Netherlands.
                    </div>
                </motion.div>
            </motion.div>

            <motion.div 
                className='flex flex-col md:flex-row-reverse relative items-center md:items-end md:justify-end gap-5 md:gap-10 mb-8 md:mb-16'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
            >
                <motion.img 
                    src={APP2} 
                    alt="Mood tracker app screen" 
                    className="w-[70%] md:w-[50%] lg:w-[40%] z-20 order-1 md:order-1" 
                    variants={floatAnimation}
                />
                <motion.div 
                    className="w-full md:max-w-[50%] bg-moody-gradient-2 p-6 md:p-16 pb-10 md:pb-24 relative order-2 md:order-2 mt-6 md:mt-0 md:mb-[8%]"
                    variants={fadeInLeft}
                >
                    <div className='absolute right-0 md:-right-24 -top-16 md:-top-52'>
                        <motion.div
                            className="w-full text-center text-[3rem] sm:text-[4rem] md:text-[7rem] lg:text-[9rem] xl:text-[11rem] font-bold text-[#c09bfa08]"
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 1 }}
                            viewport={{ once: false }}
                        >
                            WORLD
                        </motion.div>
                    </div>
                    <div className='text-2xl md:text-3xl font-bold text-white mb-2 md:mb-4'>Overview</div>
                    <div className='text-[#e0e0e0] text-base md:text-lg leading-relaxed'>
                        Excellence care clinics operates as an independent center for
                        pain treatment, aiding patients with complicated cases
                        that do not respond to usual treatments. The care is
                        delivered by pain specialists and nurses. They are based
                        in Velsen-Noord, the Netherlands.
                    </div>
                </motion.div>
            </motion.div>

            <motion.div 
                className='flex flex-col md:flex-row relative items-center md:items-end md:justify-end gap-5 md:gap-10 mb-8 md:mb-16'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
            >
                <motion.img 
                    src={APP3} 
                    alt="Mood tracker app screen" 
                    className="w-[70%] md:w-[50%] lg:w-[35%] z-20 order-1 md:order-1" 
                    variants={floatAnimation}
                />
                <motion.div 
                    className="w-full md:max-w-[50%] bg-moody-gradient-3 p-6 md:p-16 pb-10 md:pb-24 relative order-2 md:order-2 mt-6 md:mt-0 md:mb-[6%]"
                    variants={fadeInRight}
                >
                    <div className='absolute left-0 md:-left-16 -top-16 md:-top-52'>
                        <motion.div 
                            className="w-full text-center text-[3rem] sm:text-[4rem] md:text-[7rem] lg:text-[9rem] xl:text-[11rem] font-bold text-[#7ABFE608]"
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 1 }}
                            viewport={{ once: false }}
                        >
                            BODY
                        </motion.div>
                    </div>
                    <div className='text-2xl md:text-3xl font-bold text-white mb-2 md:mb-4'>Overview</div>
                    <div className='text-[#e0e0e0] text-base md:text-lg leading-relaxed'>
                        Excellence care clinics operates as an independent center for
                        pain treatment, aiding patients with complicated cases
                        that do not respond to usual treatments. The care is
                        delivered by pain specialists and nurses. They are based
                        in Velsen-Noord, the Netherlands.
                    </div>
                </motion.div>
            </motion.div>
        </div>
    )
}

export default MoodyMonthAppOverview;